module.exports = __webpack_public_path__ + "img/13-half-sm.73ce8939.jpg";